import { graphql } from "~/gql";

export const PARENT_PHASES_QUERY = graphql(/* GraphQL */ `
  query Phases($findParentMatterId: Int!) {
    findParentMatter(id: $findParentMatterId) {
      phases {
        id
        order
        title
      }
    }
  }
`);
